export default __webpack_public_path__ + "static/media/camera-3.097ca1dc.png";